import { useTranslation } from 'react-i18next';
import useWhitelabelEnvs from './useWhitelabelEnvs';

/**
 * UseCurrencyConfig hook.
 * Get currency formatting configurations from the store and i18n.
 * @returns {object} - currency, locale, decimals.
 */
const useCurrencyConfig = () => {
  const env = useWhitelabelEnvs();
  const { i18n } = useTranslation();

  // Avoid use default values because it will cause issues with the currency formatting
  return {
    currency: env.currency,
    locale: i18n.language,
    decimals: env.tripPriceDecimals,
  };
};

export default useCurrencyConfig;
